// Import Firebase modules
import { initializeApp } from 'firebase/app';
import { getFirestore, doc, updateDoc, runTransaction, setDoc, getDoc, onSnapshot, Timestamp } from 'firebase/firestore';
import { getAuth, onAuthStateChanged } from 'firebase/auth';

jQuery(document).ready(function ($) {
    if ($('.page-template-daily-draw-sheet').length > 0) {
        
        // Initialize Firebase
        let firebaseApp, db, auth, currentUser = null;
        
        // Initialize Firebase when config is available
        if (typeof firebaseConfig !== 'undefined') {
            try {
                firebaseApp = initializeApp(firebaseConfig);
                db = getFirestore(firebaseApp);
                auth = getAuth(firebaseApp);
                
                // Listen for auth state changes
                onAuthStateChanged(auth, (user) => {
                    currentUser = user;
                    if (user) {
                        // Check if user has voted when they log in
                        checkUserVote();
                    } else {
                        // Show non-voted state when not logged in
                        setUserVoted(false);
                    }
                });
                
            } catch (error) {
                console.error('Error initializing Firebase:', error);
            }
        } else {
            console.error('Firebase config not available');
        }

        // Helper function to sanitize Firestore keys
        function sanitizeFirestoreKey(key) {
            if (!key) return 'undefined_key';
            return key.toString().replace(/[\.\#\$\[\]\/]/g, '_');
        }

        // Helper function to decode HTML entities
        function decodeHtmlEntities(text) {
            if (!text) return '';
            
            try {
                // Handle common HTML entities
                let result = text
                    .replace(/&amp;/g, '&')
                    .replace(/&lt;/g, '<')
                    .replace(/&gt;/g, '>')
                    .replace(/&quot;/g, '"')
                    .replace(/&apos;/g, "'")
                    .replace(/&#39;/g, "'")
                    .replace(/&#x27;/g, "'")
                    .replace(/&#x2F;/g, '/');
                
                // Handle decimal entities (&#nnnn;)
                result = result.replace(/&#(\d+);/g, function(match, dec) {
                    try {
                        return String.fromCharCode(parseInt(dec, 10));
                    } catch (e) {
                        return match;
                    }
                });
                
                // Handle hex entities (&#xhhhh;)
                result = result.replace(/&#x([0-9a-f]+);/gi, function(match, hex) {
                    try {
                        return String.fromCharCode(parseInt(hex, 16));
                    } catch (e) {
                        return match;
                    }
                });
                
                return result;
            } catch (error) {
                console.error('Error decoding HTML entities:', error);
                return text;
            }
        }

        // Get current voting date
        function getCurrentVotingDate() {
            return window.votingDate || new Date().toISOString().split('T')[0];
        }

        // Get player data from window object
        function getPlayerData() {
            return window.votingPlayersData || [];
        }

        // Check if user has voted (localStorage and Firebase)
        async function checkUserVote() {
            const votingDate = getCurrentVotingDate();
            
            // If user is not logged in, don't check votes - just show non-voted state
            if (!currentUser) {
                setUserVoted(false);
                listenToVoteUpdates();
                return;
            }
            
            try {
                // Only check localStorage if user is logged in
                const localVote = localStorage.getItem(votingDate);
                
                if (localVote) {
                    const direction = localVote === 'left' || localVote === 'right' ? localVote : JSON.parse(localVote)?.direction;
                    if (direction) {
                        setUserVoted(true, direction);
                        // Still fetch real-time data from Firebase
                        listenToVoteUpdates();
                        return;
                    }
                }
                
                // If no local vote and user is logged in, check Firebase
                if (currentUser && db) {
                    const userDocRef = doc(db, 'userData', currentUser.uid);
                    const userDoc = await getDoc(userDocRef);
                    
                    if (userDoc.exists()) {
                        const userData = userDoc.data();
                        const userVote = userData.votes && userData.votes[votingDate];
                        
                        if (userVote) {
                            // User has voted, determine direction by comparing playerId
                            const playerData = getPlayerData();
                            if (playerData.length >= 2) {
                                const votedPlayerId = sanitizeFirestoreKey(userVote.playerId);
                                const leftPlayerId = sanitizeFirestoreKey(playerData[0].playerId || playerData[0].id);
                                const direction = votedPlayerId === leftPlayerId ? 'left' : 'right';
                                
                                // Save to localStorage for next time
                                localStorage.setItem(votingDate, direction);
                                setUserVoted(true, direction);
                            }
                        } else {
                            setUserVoted(false);
                        }
                    } else {
                        setUserVoted(false);
                    }
                } else {
                    setUserVoted(false);
                }
                
                // Always listen for real-time updates
                listenToVoteUpdates();
                
            } catch (error) {
                console.error('Error checking user vote:', error);
                setUserVoted(false);
                listenToVoteUpdates();
            }
        }

        // Set user voted state
        function setUserVoted(hasVoted, direction = null) {
            if (hasVoted) {
                $('.dds__vote').addClass('voted');
                // Add visual indicators for which player was voted for
                if (direction) {
                    $('.vote-button').each(function(index) {
                        const button = $(this);
                        const playerIndex = index + 1;
                        const isVotedPlayer = (direction === 'left' && playerIndex === 1) || (direction === 'right' && playerIndex === 2);
                        
                        if (isVotedPlayer) {
                            button.addClass('voted-player');
                        }
                    });
                }
            } else {
                $('.dds__vote').removeClass('voted');
                $('.vote-button').removeClass('voted-player');
            }
        }

        // Listen for real-time vote updates
        function listenToVoteUpdates() {
            if (!db) return;
            
            const votingDate = getCurrentVotingDate();
            const voteResultsRef = doc(db, 'votingResults', votingDate);
            
            // Set up real-time listener
            const unsubscribe = onSnapshot(voteResultsRef, (snapshot) => {
                if (snapshot.exists()) {
                    const data = snapshot.data() || {};
                    const playerData = getPlayerData();
                    
                    if (data.players && playerData.length >= 2) {
                        const leftPlayerId = sanitizeFirestoreKey(playerData[0].playerId || playerData[0].id);
                        const rightPlayerId = sanitizeFirestoreKey(playerData[1].playerId || playerData[1].id);
                        
                        const leftVotes = data.players[leftPlayerId]?.votes || 0;
                        const rightVotes = data.players[rightPlayerId]?.votes || 0;
                        
                        calculatePercentage(leftVotes, rightVotes);
                    }
                } else {
                    // No votes yet, show 0-0
                    calculatePercentage(0, 0);
                }
            }, (error) => {
                console.error("Error listening to vote updates:", error);
            });
            
            // Store unsubscribe function for cleanup
            window.voteListener = unsubscribe;
        }

        // Calculate and display vote percentages
        function calculatePercentage(votes_player_1, votes_player_2) {
            const totalVotes = votes_player_1 + votes_player_2;
            
            if (totalVotes === 0) {
                // No votes yet
                $('#first_player_percentage').html('50%');
                $('#second_player_percentage').html('50%');
                $('#total-votes').html('0 Votes');
                $('#first_player_percentage_container').css('width', '50%');
                $('#second_player_percentage_container').css('width', '50%');
                return;
            }
            
            const player1Percentage = Math.round((votes_player_1 / totalVotes) * 100);
            const player2Percentage = 100 - player1Percentage;

            $('#first_player_percentage').html(player1Percentage + '%');
            $('#second_player_percentage').html(player2Percentage + '%');
            $('#total-votes').html(totalVotes + ' Votes');

            $('#first_player_percentage_container').css('width', player1Percentage + '%');
            $('#second_player_percentage_container').css('width', player2Percentage + '%');
            
            // Add vote percentage to each vote button
            $('.vote-button').each(function(index) {
                const button = $(this);
                const playerIndex = index + 1;
                const playerVotes = playerIndex === 1 ? votes_player_1 : votes_player_2;
                const playerPercentage = totalVotes > 0 ? Math.round((playerVotes / totalVotes) * 100) : 50;
                
                // Remove previous percentage displays
                button.find('.vote-percentage, .backogrund-percentage').remove();
                
                const playerBlock = button.find('.player__block');
                if (playerBlock.length) {
                    playerBlock.append('<div class="vote-percentage">' + playerPercentage + '%</div>');
                    playerBlock.append('<div class="backogrund-percentage" style="width: ' + playerPercentage + '%;"></div>');
                }
            });
        }

        // Save vote to user's Firebase document
        async function saveVoteToUserData(direction) {
            if (!currentUser || !db) {
                return false;
            }
            
            try {
                const votingDate = getCurrentVotingDate();
                const playerData = getPlayerData();
                
                if (playerData.length < 2) {
                    console.error('Insufficient player data');
                    return false;
                }
                
                const votedPlayerData = direction === 'left' ? playerData[0] : playerData[1];
                const playerId = votedPlayerData.playerId || votedPlayerData.id;
                
                const userDocRef = doc(db, 'userData', currentUser.uid);
                const currentTimestamp = Timestamp.fromDate(new Date());
                
                const updateData = {
                    [`votes.${votingDate}`]: {
                        playerId: playerId,
                        timestamp: currentTimestamp
                    },
                    updatedAt: currentTimestamp
                };
                
                await updateDoc(userDocRef, updateData);
                return true;
                
            } catch (error) {
                console.error('Error saving vote to user data:', error);
                return false;
            }
        }

        // Update voting results collection
        async function updateVotingResults(votingDate, playerId, direction) {
            if (!db) return false;
            
            try {
                const sanitizedPlayerId = sanitizeFirestoreKey(playerId);
                const voteResultsRef = doc(db, 'votingResults', votingDate);
                
                const playerData = getPlayerData();
                const otherPlayerData = direction === 'left' ? playerData[1] : playerData[0];
                const otherPlayerId = sanitizeFirestoreKey(otherPlayerData?.playerId || otherPlayerData?.id || '');
                
                const currentDoc = await getDoc(voteResultsRef);
                
                if (!currentDoc.exists()) {
                    // Create new document
                    const newDocData = {
                        date: votingDate,
                        totalVotes: 1,
                        lastUpdated: Timestamp.fromDate(new Date()),
                        players: {
                            [sanitizedPlayerId]: { votes: 1 },
                            [otherPlayerId]: { votes: 0 }
                        }
                    };
                    
                    await setDoc(voteResultsRef, newDocData);
                } else {
                    // Update existing document using transaction
                    await runTransaction(db, async (transaction) => {
                        const docSnapshot = await transaction.get(voteResultsRef);
                        
                        if (!docSnapshot.exists()) {
                            throw new Error("Document does not exist in transaction!");
                        }
                        
                        const data = docSnapshot.data() || { totalVotes: 0, players: {} };
                        
                        if (!data.players) {
                            data.players = {};
                        }
                        
                        if (!data.players[sanitizedPlayerId]) {
                            data.players[sanitizedPlayerId] = { votes: 0 };
                        }
                        if (otherPlayerId && !data.players[otherPlayerId]) {
                            data.players[otherPlayerId] = { votes: 0 };
                        }
                        
                        const currentVotes = data.players[sanitizedPlayerId]?.votes || 0;
                        
                        const updateData = {
                            totalVotes: (data.totalVotes || 0) + 1,
                            lastUpdated: Timestamp.fromDate(new Date()),
                            [`players.${sanitizedPlayerId}.votes`]: currentVotes + 1
                        };
                        
                        transaction.update(voteResultsRef, updateData);
                    });
                }
                
                return true;
                
            } catch (error) {
                console.error('Error updating voting results:', error);
                throw error;
            }
        }

        // Handle vote click
        async function handleVote(direction, playerIndex) {
            // Check if user is logged in
            if (!currentUser) {
                // Redirect to login page if needed
                if (window.login_link) {
                    window.location.href = window.login_link;
                }
                return;
            }
            
            const votingDate = getCurrentVotingDate();
            
            // Check if user has already voted
            const existingVote = localStorage.getItem(votingDate);
            if (existingVote) {
                return;
            }
            
            // Show loading state
            $('.vote-button').prop('disabled', true);
            $('.dds__vote').addClass('voting-in-progress');
            
            try {
                const playerData = getPlayerData();
                if (playerData.length < 2) {
                    throw new Error('Player data not available');
                }
                
                const votedPlayerData = direction === 'left' ? playerData[0] : playerData[1];
                const playerId = votedPlayerData.playerId || votedPlayerData.id;
                
                // Save vote to user's document (priority)
                const savedToFirestore = await saveVoteToUserData(direction);
                
                if (!savedToFirestore) {
                    console.warn('Failed to save vote to Firestore userData');
                }
                
                // Save to localStorage for local cache
                localStorage.setItem(votingDate, direction);
                
                // Update voting results collection
                try {
                    await updateVotingResults(votingDate, playerId, direction);
                } catch (votingResultsError) {
                    console.error('Error updating votingResults collection, but user vote was still saved:', votingResultsError);
                }
                
                // Update UI
                setUserVoted(true, direction);
                
            } catch (error) {
                console.error('Error handling vote:', error);
                // alert('Failed to save your vote. Please try again.');
                
                // Reset state on error
                localStorage.removeItem(votingDate);
                setUserVoted(false);
                
            } finally {
                // Remove loading state
                $('.vote-button').prop('disabled', false);
                $('.dds__vote').removeClass('voting-in-progress');
            }
        }

        // Attach click handlers to vote buttons
        $('.dds__vote__players button.vote-button').on('click', function() {
            const playerIndex = parseInt($(this).data('player'));
            const direction = playerIndex === 1 ? 'left' : 'right';
            
            handleVote(direction, playerIndex);
        });

        // Initialize when page loads
        $(document).ready(function() {
            // Wait a bit for Firebase to initialize
            setTimeout(() => {
                checkUserVote();
            }, 1000);
        });

        // Cleanup listener when page unloads
        $(window).on('beforeunload', function() {
            if (window.voteListener) {
                window.voteListener();
            }
        });
    }
});